/** Own marks propagate through a space tree; iterative traversal also handles cycles. */
export function effectiveTranslatable(pages: readonly { id: string; parentId: string | null; translatable: boolean }[]): Set<string> {
  const children = new Map<string, string[]>()
  const effective = new Set<string>()
  const queue: string[] = []
  for (const page of pages) {
    if (page.parentId !== null) {
      const siblings = children.get(page.parentId) ?? []
      siblings.push(page.id)
      children.set(page.parentId, siblings)
    }
    if (page.translatable) { effective.add(page.id); queue.push(page.id) }
  }
  for (let index = 0; index < queue.length; index++) {
    for (const id of children.get(queue[index]) ?? []) {
      if (effective.has(id)) continue
      effective.add(id)
      queue.push(id)
    }
  }
  return effective
}
